import { render } from "./NotificationsChatbot.vue?vue&type=template&id=3d4395db&scoped=true"
import script from "./NotificationsChatbot.vue?vue&type=script&lang=js"
export * from "./NotificationsChatbot.vue?vue&type=script&lang=js"

import "./NotificationsChatbot.vue?vue&type=style&index=0&id=3d4395db&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4395db"]])

export default __exports__